import { FC } from 'react';
import { CategoryTitleStoryblok } from 'storyblok-types';
import { CategoryHeadline } from 'molecules/CategoryHeadline';
import { IStoryBlokComponentProps } from 'pages/StoryBlok/types';

export const CategoryTitle: FC<
  IStoryBlokComponentProps<CategoryTitleStoryblok>
> = ({ blok }) => {
  return !blok.title ? null : <CategoryHeadline title={blok.title} />;
};
